module.exports = __webpack_public_path__ + "img/p2-13.74f82021.png";